var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"patent",attrs:{"to":{
        name: 'legalDetail',
        query: {
            id: _vm.info.id
        }
    }}},[_c('el-image',{attrs:{"src":_vm.getImg(_vm.info.img),"fit":"cover"}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.info.summary))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.info.issuedAt))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }